// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Domains .domain-row {
  display: flex;
  align-items: flex-end;
  gap: 8px;
}
.Domains .domain-row .domain-input {
  flex: 1;
  min-width: 0;
}
.Domains .domain-row .domain-remove {
  margin-bottom: 6px;
}`, "",{"version":3,"sources":["webpack://./src/web/client/src/components/Users/IdentityProviders/Sidebar/Domains.scss"],"names":[],"mappings":"AAEE;EACE,aAAA;EACA,qBAAA;EACA,QAAA;AADJ;AAGI;EACE,OAAA;EACA,YAAA;AADN;AAII;EACE,kBAAA;AAFN","sourcesContent":[".Domains {\n\n  .domain-row {\n    display: flex;\n    align-items: flex-end;\n    gap: 8px;\n\n    .domain-input {\n      flex: 1;\n      min-width: 0;\n    }\n\n    .domain-remove {\n      margin-bottom: 6px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
